export var StarPhonicsCategory;
(function (StarPhonicsCategory) {
    StarPhonicsCategory["BLENDS"] = "Blends";
    StarPhonicsCategory["CONTRACTIONS"] = "Contractions";
    StarPhonicsCategory["CVC"] = "CVC";
    StarPhonicsCategory["CVCC"] = "CVCC";
    StarPhonicsCategory["CVCCVC"] = "CVCCVC";
    StarPhonicsCategory["CVCE"] = "CVCe";
    StarPhonicsCategory["DIGRAPHS"] = "Digraphs";
    StarPhonicsCategory["LV_SUFFIX"] = "LV Suffix";
    StarPhonicsCategory["PREFIX"] = "Prefix";
    StarPhonicsCategory["R_CONTROLLED"] = "R-Controlled";
    StarPhonicsCategory["SV_SUFFIX"] = "SV Suffix";
    StarPhonicsCategory["VOWEL_TEAMS"] = "Vowel Teams";
})(StarPhonicsCategory || (StarPhonicsCategory = {}));
export var StarPhonicsSkill;
(function (StarPhonicsSkill) {
    StarPhonicsSkill["A"] = "a";
    StarPhonicsSkill["ABLE"] = "able";
    StarPhonicsSkill["AD"] = "ad";
    StarPhonicsSkill["AI"] = "ai";
    StarPhonicsSkill["AR"] = "ar";
    StarPhonicsSkill["AU"] = "au";
    StarPhonicsSkill["AW"] = "aw";
    StarPhonicsSkill["AY"] = "ay";
    StarPhonicsSkill["BE"] = "be";
    StarPhonicsSkill["BL"] = "bl";
    StarPhonicsSkill["BR"] = "br";
    StarPhonicsSkill["CH"] = "ch";
    StarPhonicsSkill["CK"] = "ck";
    StarPhonicsSkill["CL"] = "cl";
    StarPhonicsSkill["CON"] = "con";
    StarPhonicsSkill["CR"] = "cr";
    StarPhonicsSkill["D"] = "d";
    StarPhonicsSkill["DE"] = "de";
    StarPhonicsSkill["DIS"] = "dis";
    StarPhonicsSkill["DR"] = "dr";
    StarPhonicsSkill["E"] = "e";
    StarPhonicsSkill["EA"] = "ea";
    StarPhonicsSkill["ED"] = "ed";
    StarPhonicsSkill["EE"] = "ee";
    StarPhonicsSkill["ENCE"] = "ence";
    StarPhonicsSkill["ENT"] = "ent";
    StarPhonicsSkill["ER"] = "er";
    StarPhonicsSkill["EST"] = "est";
    StarPhonicsSkill["EW"] = "ew";
    StarPhonicsSkill["EX"] = "ex";
    StarPhonicsSkill["FL"] = "fl";
    StarPhonicsSkill["FUL"] = "ful";
    StarPhonicsSkill["GR"] = "gr";
    StarPhonicsSkill["I"] = "i";
    StarPhonicsSkill["IGH"] = "igh";
    StarPhonicsSkill["IN"] = "in";
    StarPhonicsSkill["ING"] = "ing";
    StarPhonicsSkill["IR"] = "ir";
    StarPhonicsSkill["ISH"] = "ish";
    StarPhonicsSkill["IVE"] = "ive";
    StarPhonicsSkill["LESS"] = "less";
    StarPhonicsSkill["LL"] = "ll";
    StarPhonicsSkill["LY"] = "ly";
    StarPhonicsSkill["M"] = "m";
    StarPhonicsSkill["MENT"] = "ment";
    StarPhonicsSkill["MIS"] = "mis";
    StarPhonicsSkill["NESS"] = "ness";
    StarPhonicsSkill["NG"] = "ng";
    StarPhonicsSkill["O"] = "o";
    StarPhonicsSkill["OA"] = "oa";
    StarPhonicsSkill["OE"] = "oe";
    StarPhonicsSkill["OI"] = "oi";
    StarPhonicsSkill["OO"] = "oo";
    StarPhonicsSkill["OR"] = "or";
    StarPhonicsSkill["OU"] = "ou";
    StarPhonicsSkill["OW"] = "ow";
    StarPhonicsSkill["OY"] = "oy";
    StarPhonicsSkill["PH"] = "ph";
    StarPhonicsSkill["PL"] = "pl";
    StarPhonicsSkill["PRE"] = "pre";
    StarPhonicsSkill["PRO"] = "pro";
    StarPhonicsSkill["RE"] = "re";
    StarPhonicsSkill["S"] = "s";
    StarPhonicsSkill["SH"] = "sh";
    StarPhonicsSkill["SK"] = "sk";
    StarPhonicsSkill["SL"] = "sl";
    StarPhonicsSkill["SN"] = "sn";
    StarPhonicsSkill["SP"] = "sp";
    StarPhonicsSkill["ST"] = "st";
    StarPhonicsSkill["TH"] = "th";
    StarPhonicsSkill["TION"] = "tion";
    StarPhonicsSkill["TR"] = "tr";
    StarPhonicsSkill["TURE"] = "ture";
    StarPhonicsSkill["U"] = "u";
    StarPhonicsSkill["UE"] = "ue";
    StarPhonicsSkill["UN"] = "un";
    StarPhonicsSkill["UR"] = "ur";
    StarPhonicsSkill["VE"] = "ve";
    StarPhonicsSkill["WH"] = "wh";
    StarPhonicsSkill["Y"] = "y";
    StarPhonicsSkill["A_I"] = "a/i";
    StarPhonicsSkill["E_U"] = "e/u";
    StarPhonicsSkill["I_O"] = "i/o";
    StarPhonicsSkill["O_E"] = "o/e";
    StarPhonicsSkill["U_A"] = "u/a";
    StarPhonicsSkill["N_T"] = "n't";
})(StarPhonicsSkill || (StarPhonicsSkill = {}));
//# sourceMappingURL=star-phonics.js.map